import { gql } from '@apollo/client';

export const GET_PROJECT_WITH_CRITICAL_PERIODS = gql`
  query GetProjectWithRisk($projectId: ID!) {
    baseProject(id: $projectId) {
      id
      criticalPeriods {
        id
        projectId
        title
        description
        startDate
        endDate
        type
        createdBy
      }
      accessInfo {
        id
        sections {
          section
          allowedActions
        }
      }
    }
  }
`;
